import React from 'react';
import { useResponsive } from '@parsina/framework';

import PatientsWeb from './Patients.web.jsx';
import PatientsMobile from './Patients.mobile.jsx';

// «بیماران» — two surfaces, one list.
//
// Both read the same query through the same hook, filter and sort with the same
// pure functions, and raise the same two dialogs. What forks is the shape of a
// row: a table on a monitor, a card under a thumb.

const PatientsScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <PatientsMobile /> : <PatientsWeb />;
};

export default PatientsScreen;
